module.exports = __webpack_public_path__ + "static/media/alibaba-appstore.e85b9782.svg";